import BuildingMajoritiesORM from "@/store/orm-axios/models/BuildingMajorities";

export default {
  FETCH(buildingId) {
    return new Promise((resolve, reject) => {
      BuildingMajoritiesORM.api()
        .FETCH(buildingId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  POST(item) {
    return new Promise((resolve, reject) => {
      BuildingMajoritiesORM.api()
        .POST(item)
        .then(res => {
          resolve(res.response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  ADD_BULK_MAJORITIES(item) {
    return new Promise((resolve, reject) => {
      BuildingMajoritiesORM.api()
        .ADD_BULK_MAJORITIES(item)
        .then(res => {
          resolve(res.response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
